import React from 'react';
import './Offer.css'; // Import your CSS file

import { Button } from '../../components';



const Offer = ({ offer }) => {

  const { image, title, description, link } = offer; // Extracting data from plan

  return (
            <div className='offer-item'>

                <img src={image} alt={title} /> {/* Offer Image */}
                <div className="content">
                  <p>{description}</p> {/* Offer Description */}
                  <h3>{title}</h3> {/* Offer Title */}
                  <Button link={link} title={'Explore Tours'} /> {/* Shop Now Button */}
                </div>

            </div>
  );
};

export default Offer;